import { render } from "./BarSpacer.vue?vue&type=template&id=61af09ed"
const script = {}

import exportComponent from "/Users/romain/Developer/vue-file-toolbar-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__